import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  modalPlaceholderOverlay: {
    position: 'fixed',
    backgroundColor: 'var(--modal-mask)',
    width: '100%',
    height: '100%',
    left: 0,
    top: 0,
    zIndex: 99999,
    display: 'grid',

    '&:has(.default)': {
      placeItems: 'center',
    },

    '&:has(.side)': {
      placeItems: 'end',
    },
  },

  modalPlaceholder: {
    overflow: 'hidden',
    display: 'grid',

    '& .sub-header': {
      height: '42px',

      '@media screen and (min-width: 1441px)': {
        height: '48px',
      },
    },

    '& .body': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },

    '& .footer': {
      padding: '8px 16px 16px',
      height: '54px',
      display: 'flex',
      gap: '16px',

      '& .brick': {
        width: '100%',
        height: '100%',
      },

      '@media screen and (min-width: 1441px)': {
        height: '60px',
      },
    },
  },

  default: {
    width: 'fit-content',
    borderRadius: '4px',

    '& .header': {
      height: '36px',
      backgroundColor: `var(--primary-main)!important`,
    },

    '& .body, & .footer, & .sub-header': {
      backgroundColor: 'var(--background-paper)',
    },

    '&.sm': {
      '& .body': {
        width: 'var(--modal-sm-w)',
        height: 'var(--modal-sm-h)',
      },
    },

    '&.md': {
      '& .body': {
        width: 'var(--modal-sm-w)',
        height: 'var(--modal-md-h)',
      },
    },

    '&.lg': {
      '& .body': {
        width: 'var(--modal-lg-w)',
        height: 'var(--modal-lg-h)',
      },
    },

    '&.xlg': {
      '& .body': {
        width: 'var(--modal-lg-w)',
        height: 'var(--modal-xlg-h)',
      },
    },

    '&.xxlg': {
      '& .body': {
        backgroundColor: 'var(--selection-hover)',
        width: 'var(--modal-xxlg-w)',
        height: 'var(--modal-xxlg-h)',
      },
    },
  },

  side: {
    gridTemplateRows: '1fr auto',
    height: '100%',

    'body:has(#playBarLayout) &': {
      paddingBottom: 'var(--song-player-h)',
    },

    '&:has(.header)': {
      gridTemplateRows: 'auto 1fr auto',
    },

    '& .header': {
      height: '62px',

      '@media screen and (min-width: 1441px)': {
        height: '84px',
      },
    },

    '& .header, & .footer, & .sub-header': {
      backgroundColor: 'var(--background-paper)',
    },

    '& .body': {
      backgroundColor: 'var(--primary-lighty)',
    },

    '&.sm': {
      width: 'var(--modal-side-sm-w)',
    },

    '&.md': {
      width: 'var(--modal-side-md-w)',
    },
  },
}));

export default useStyles;
